export default  {"src":"/_next/static/image/public/assets/icons/dropdown-arrow.8c8f9efaec37e4b35899a8bcd1e6fdc8.svg","height":6,"width":11};